import GoogleDataFetcher from '../../utilities/googleDataFetcher';

export default function getGoogleIDs(sender) {
    console.log('getGoogleIDs called from:', sender);

    return GoogleDataFetcher.getGoogleData(sender);
}

export const debugGoEvent = (data) =>
{
    window.dataLayer.push({
        ...data,
    });
}

